import Header from "../components/header.jsx";
import Sidebar from "../components/sidebar.jsx";
import PMPaidCustomer from "../components/pmPaidCustomer.jsx";
import Footer from "../components/footer.jsx";

function PMPaidCustomerpage() {
    return (
        <div>
        <div className='wrapper'>
          <Header />
          <Sidebar /> 
          <PMPaidCustomer/> 
        </div>
        <Footer /> 
      </div>
      // <Login/>
      );
}
export default PMPaidCustomerpage;
